import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

interface ThinkingBlockProps {
  text: string;
  startedAt: number;
  completedAt?: number;
  isStreaming: boolean;
}

const ThinkingBlock: React.FC<ThinkingBlockProps> = ({
  text,
  startedAt,
  completedAt,
  isStreaming,
}) => {
  const [expanded, setExpanded] = useState(false);
  const isActive = !completedAt && isStreaming;
  const duration = completedAt
    ? Math.round((completedAt - startedAt) / 1000)
    : null;

  return (
    <div className="my-1">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-1.5 text-[10px] text-[var(--color-text-muted)] hover:text-[var(--color-text-secondary)] transition-colors"
      >
        {expanded ? (
          <ChevronDown className="w-3 h-3" />
        ) : (
          <ChevronRight className="w-3 h-3" />
        )}
        {isActive ? (
          <span className="italic">
            Thinking
            <span className="inline-flex w-4">
              <span className="animate-pulse">...</span>
            </span>
          </span>
        ) : (
          <span className="italic">
            Thought for {duration}s
          </span>
        )}
      </button>
      {expanded && (
        <div className="mt-1 ml-4.5 pl-2 border-l-2 border-[var(--color-border)] text-[10px] text-[var(--color-text-muted)] italic whitespace-pre-wrap leading-relaxed max-h-40 overflow-y-auto">
          {text}
        </div>
      )}
    </div>
  );
};

export default ThinkingBlock;
